// batch-66 verkoop-extractie (FO-493) - de pure kern van de factuurextractie:
// tekst-hulpjes (kerning-bestendig), de Finqle-tekstlezer, profielherkenning,
// naverwerking (AI + PDF-tekst -> velden met zekerheid, IBAN-blokkade), de
// leerlus (correcties -> patroon -> voorstel) en de regel-dagregel-koppeling.
export * from './tekst'
export * from './finqle'
export * from './herkenning'
export * from './naverwerking'
export * from './correcties'
export * from './werkbon-koppeling'
